import type { SVGProps } from 'react';

export function IconVimeo(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
            <path d="M23.9765 6.4168c-.105 2.338-1.739 5.5429-4.894 9.6088-3.2679 4.247-6.0258 6.3699-8.2898 6.3699-1.409 0-2.578-1.294-3.553-3.881l-1.9179-7.1138c-.719-2.584-1.4899-3.878-2.3159-3.878-.17 0-.788.373-1.859 1.109L0 7.2138c1.2-1.052 2.386-2.106 3.548-3.164 1.599-1.38 2.8-2.109 3.593-2.18 1.879-.18 3.037 1.104 3.472 3.857.465 2.967.789 4.816.965 5.542.539 2.442 1.13 3.66 1.777 3.66.502 0 1.256-.795 2.265-2.383 1.004-1.589 1.54-2.797 1.612-3.628.144-1.371-.395-2.061-1.614-2.061-.574 0-1.167.121-1.777.391 1.186-3.868 3.434-5.757 6.762-5.637 2.473.06 3.628 1.664 3.493 4.797l-.02.017z" />
        </svg>
    );
}
